import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, Output, EventEmitter, } from '@angular/core';
import mixinDisabled from '../../mixins/disabled';
import { PhxButtonSize, PhxButtonType, PhxButtonRole, PhxDropdownComponent } from '../../public-api';
import { PhxBackground } from '../../types';
import { POSITION_TYPE } from '../dropdown/overlay-position';

const baseButtonMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-split-button',
  styleUrls: ['./phx-split-button.scss'],
  templateUrl: './phx-split-button.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: [
    'disabled'
  ],
  host: {
    '[class.phx-has-shadow]': `phxHasShadow === true`,
    '[class.phx-button-lg]': `phxSize === 'large'`,
    '[class.phx-button-md]': `phxSize === 'medium'`,
    '[class.phx-button-sm]': `phxSize === 'small'`,
  },
})
// todo: fix divider not having proper color on different backgrounds
export class PhxSplitButtonComponent extends baseButtonMixin {
  @Input() public phxSize: PhxButtonSize = 'medium';
  @Input() public phxBackground: PhxBackground = 'standard';
  @Input() public phxButtonType: PhxButtonType = 'default';
  @Input() public phxButtonRole: PhxButtonRole = 'primary';
  @Input() public phxLoading: boolean = false;
  @Input() public phxPrefixIcon: string;
  @Input() public phxDropdownTemplate: PhxDropdownComponent;
  @Input() public phxDropdownPosition: POSITION_TYPE = 'bottomRight';
  @Input() public phxHasShadow: boolean = false;
  @Output() public phxOnClick: EventEmitter<MouseEvent | KeyboardEvent> = new EventEmitter<MouseEvent>();

  public handleClick(event: MouseEvent | KeyboardEvent): void {
    this.phxOnClick.emit(event);
  }

}

